<template>
  <v-row>
     <v-col cols="12">
      <v-card class="px-0">
        <v-skeleton-loader v-if="$store.state.subscriptions.retrieveLoader" transition="fade-transition" type="toolbar"/>
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Productos</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-query-builder :query-map="rules" model="product" class="mr-1" />
              <v-btn id="it-product-new" @click="dialogProduct=true" outlined color="secondary"><v-icon left small>mdi-plus</v-icon> Nuevo</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <v-skeleton-loader v-if="$store.state.subscriptions.retrieveLoader" transition="fade-transition" type="table"/>
          <template v-else>
            <v-col v-if="!productsList.length" class="text-center py-5">
              <v-icon class="d-block" color="secondary" size="70">mdi-file</v-icon>
              <span class="d-block subtitle-1">Aún no tienes productos para suscribir</span>
              <v-btn class="my-5" @click="dialogProduct=true" outlined>Crear un producto</v-btn>
            </v-col>
            <template v-else>
              <v-data-table :headers="headers" :items="productsList" :items-per-page="pagination" mobile-breakpoint hide-default-footer hide-default-header disable-sort @click:row="(productsList) => { $router.push({ name: 'ProductRetrieveUpdate', params: { id: productsList.id }}) }" style="cursor: pointer">
                <!-- header -->
                <template v-slot:header="{ props: { headers } }">
                  <VTableHeaders :headers="headers" @sort="setSort" />
                </template>
                <!-- end header -->
                <template v-slot:[`item.name`]="{item}">
                  <span class="text--secondary font-weight-medium">{{item.name}}</span>
                </template>
                <template v-slot:[`item.plans`]="{item}">
                  <template v-if="item.plans.length === 1">
                    <span class="mr-1" v-if="item.plans[0].tiers.length">Desde</span>
                    <span class="text--secondary font-weight-medium">{{item.plans[0].amount | number(item.plans[0].currency.rounded)}}</span>
                    <span class="ml-1">{{item.plans[0].currency.id}} / {{item.plans[0].frequency.name}}</span>
                  </template>
                  <template v-else-if="item.plans.length > 1">
                    <span class="text--secondary font-weight-medium">{{item.plans.length}}</span>
                    <span class="ml-1">planes de precios</span>
                  </template>
                  <template v-else>
                    <span>El producto no tiene planes de precios</span>
                  </template>
                </template>
              </v-data-table>
              <template v-if="showPagination || showAll">
                <v-divider />
                <v-row class="mx-0" align="center">
                  <template v-if="showPagination">
                    <v-col cols="6">
                      <span class="body-2 text--secondary">{{count}} registros</span>
                    </v-col>
                    <v-col cols="6" class="text-right">
                      <v-pagination v-model="page" :length="totalPages" total-visible="6" />
                    </v-col>
                  </template>
                </v-row>
              </template>
            </template>
          </template>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- dialog product -->
    <v-dialog v-model="dialogProduct" width="600" persistent no-click-animation scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Crear un producto</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="dialogProduct=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-col cols="12">
            <span>Un producto es algo a lo que tus clientes se suscriben. Por ejemplo, una membresía de un software o un gimnasio. Una vez creado puedes definir diferentes planes de precios para este producto.</span>
          </v-col>
          <v-list class="v-list-form py-6 transparent">
            <v-list-item class="py-1">
              <v-list-item-title>
                Nombre
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span>Este nombre aparecerá en las futuras facturas.</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field id="it-product-name" v-model="$v.newProduct.name.$model" :error="$v.newProduct.name.$error" background-color="white" outlined required single-line dense maxlength="80" placeholder="Escribe un nombre" hide-details />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>
                Etiqueta de unidad
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span>Representación de una unidad del producto, como un pase o una cuenta. Aparecerá en el campo de "unidad" de las facturas.</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field id="it-product-unit_label" v-model="$v.newProduct.unit_label.$model" :error="$v.newProduct.unit_label.$error" background-color="white" outlined required single-line dense maxlength="12" hide-details />
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogProduct=false" outlined color="secondary">Cancelar</v-btn>
          <v-btn id="it-product-create" @click="createProduct" :loading="$store.state.subscriptions.createLoader" color="primary">Crear producto</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog product -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import ListViewMixin from '@/mixins/ListViewMixin'
import VTableHeaders from '@/components/VTable/VTableHeaders'
export default {
  components: {
    VQueryBuilder,
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
      newProduct: {
        name: '',
        unit_label: ''
      },
      dialogProduct: false,
      rules: [
        {
          type: 'text',
          id: 'name',
          label: 'Nombre del producto',
          operators: ['contiene']
        },
        {
          type: 'text',
          id: 'plans__name',
          label: 'Nombre del plan',
          operators: ['contiene']
        },
        {
          type: 'numeric',
          id: 'plans__amount',
          label: 'Precio del plan',
          operators: ['es igual', 'es menor a', 'es mayor a']
        }
      ],
      headers: [
        { text: 'Nombre', value: 'name', class: 'font-weight-bold', sortable: true },
        { text: 'Precios', value: 'plans', align: 'end', sortable: false }
      ]
  }),
  computed: mapState({
    account: state => state.auth.account.id,
    count: state => state.subscriptions.productsCount,
    productsList: state => state.subscriptions.productsList
  }),
  methods: {
    getList () {
      this.$store.dispatch('subscriptions/LIST', {
        resource: 'products',
        query: this.$route.query
      })
    },
    createProduct () {
      this.$v.newProduct.$touch()
      if (this.$v.newProduct.$invalid) {
        return false
      }
      this.$store.dispatch('subscriptions/CREATE', {
        resource: 'products',
        payload: this.newProduct
      })
      .then((response) => {
        this.$dialog.message.info('El producto ha sido creado')
        this.$router.push({
          name: 'PlanCreate',
          query: {
            product: response.data.id
          }
        })
      })
      .catch(() => {
        this.$dialog.message.error('Error al crear el producto')
      })
    }
  },
  validations: {
    newProduct: {
      name: {
        required,
        maxLength: maxLength(80)
      },
      unit_label: {
        required,
        maxLength: maxLength(12)
      }
    }
  }
}
</script>